import { render, staticRenderFns } from "./DefaultMaterial.vue?vue&type=template&id=00a9a3c2&scoped=true&"
import script from "./DefaultMaterial.vue?vue&type=script&lang=js&"
export * from "./DefaultMaterial.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMaterial.vue?vue&type=style&index=0&id=00a9a3c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9a3c2",
  null
  
)

export default component.exports